// extracted by mini-css-extract-plugin
module.exports = {"optionName":"HardwareBundleOptions_optionName__G2waK"};